import React from 'react';
import ReactDOM from 'react-dom/client';

/* ── Global Styles (order matters) ── */
import './styles/theme.css';
import './styles/glass.css';
import './styles/layout.css';
import './styles/animations.css';

import App from './App';
import { installGlobalAuthInterceptors } from './utils/authInterceptors';

/* ── Patch ResizeObserver to use requestAnimationFrame ──
   Prevents "ResizeObserver loop completed with undelivered notifications"
   from BlockNoteView / ProseMirror when editing table columns.
   Placed after imports to satisfy eslint import/first rule. */
if (typeof window !== 'undefined' && window.ResizeObserver) {
  const OriginalResizeObserver = window.ResizeObserver;
  window.ResizeObserver = class PatchedResizeObserver extends OriginalResizeObserver {
    constructor(callback: ResizeObserverCallback) {
      super((entries: ResizeObserverEntry[], observer: ResizeObserver) => {
        requestAnimationFrame(() => callback(entries, observer));
      });
    }
  };
}

// Global session-expiry handling for both fetch and axios.
installGlobalAuthInterceptors();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
